/*Back In stock Functionality */
$(document).on('click', '#bis_trigger_click', function(e){
    e.preventDefault();
    $('.BIS_trigger').click();
});
/*Back In stock Functionality Close*/
/* size values ascending order*/
selElem = document.getElementById('select_size');
/*Size Filter Hide */

/* Size Filter Hide close*/
function sortSelect(selElem) {
    var tmpAry = new Array();
    for (var i = 0; i < selElem.options.length; i++) {
        tmpAry[i] = new Array();
        tmpAry[i][0] = selElem.options[i].text;
        tmpAry[i][1] = selElem.options[i].value;
    }

    tmpAry.sort();
    while (selElem.options.length > 0) {
        selElem.options[0] = null;
    }
    var op1;
    for (var i = 0; i < tmpAry.length - 1; i++) {
        op1 = new Option(tmpAry[tmpAry.length - 1][0], tmpAry[tmpAry.length - 1][1]);
        var op = new Option(tmpAry[i][0], tmpAry[i][1], false);
        selElem.options[i + 1] = op;
    }
    selElem.options[0] = op1;


    return;
}
if (selElem) {
    sortSelect(selElem);
    $('#select_size').val('');
}

/* size values ascending order close*/
/* Search Function*/

function announcementW() {
    if ($('.announcement-bar__message').length && $('.announcement-bar__message').is(':visible')) {

        if ($('.announcement-bar__message').width() > $(window).width() - (($('.header-icons').width() + 50) * 2)) {
            $('.announcement-bar__message').addClass('over-width').css('opacity', 0);
        } else if ($('.announcement-bar__message').hasClass('over-width')) {
            $('.announcement-bar__message').removeClass('over-width').css('opacity', 1);
        }
    }
}
$(window).resize(function () {
    announcementW();
})
$(document).ready(function () {
    announcementW();
    var headericonW = $('.header-icons').width();
    $("#search-box").on('click', function (e) {
        e.preventDefault();
        var hideAnnouce = false;
        var getWinWidth = ($(window).width() - ((headericonW + 50) * 2)) - $('.announcement-bar__message').width();

        if (getWinWidth < headericonW * 2) {
            hideAnnouce = true;
        } else {
            hideAnnouce = false;
        }

        if ($(this).parent('li').hasClass('active')) {
            $(this).parent('li').removeClass('active');
            $(this).parent('li').find('.input-group-field').blur();

            if (hideAnnouce && !$('.announcement-bar__message').hasClass('over-width')) {
                $('.announcement-bar__message').css('opacity', 1);
            }
        } else {
            $(this).parent('li').addClass('active');
            $(this).parent('li').find('.input-group-field').focus();
            if (hideAnnouce && !$('.announcement-bar__message').hasClass('over-width')) {
                $('.announcement-bar__message').css('opacity', 0);
            }
        }
    });


    $('#select_size').selectbox();
    $('.stamped-summary-actions-newreview').on('click', function(){


        // if any scroll is attempted, set this to the previous value
        document.onscroll = function() {
             scrollTop = document.documentElement.scrollTop;
             scrollLeft = document.documentElement.scrollLeft,
            window.scrollTo(scrollLeft, scrollTop);
        };
    })
});
/* Search Function Close*/


/* Get Url Parameters For Filter*/
function getUrlParams() {
    var result = {};
    var params = (window.location.search.split('?')[1] || '').split('&');
    for (var param in params) {
        if (params.hasOwnProperty(param)) {
            paramParts = params[param].split('=');
            result[paramParts[0]] = decodeURIComponent(paramParts[1] || "");
        }
    }

    return result;
}
size_muliple = getUrlParams();

/* Get Url Parameters For Filter Close*/

/* Add Filter Active Button For Size And Category */
var getUrl_size = window.location.href.split('?q=').pop();
if (getUrl_size.search('https://') == -1) {

    if (size_muliple.q) {
        jQuery('#select_size').val(size_muliple.q);
    }
    else {
        jQuery('#select_size').val(getUrl_size);
    }

    size_guide = getUrl_size.toLowerCase();



}

var getUrl_style = window.location.href.split('types=').pop();


/* Add Filter Active Button For Size And Category */
/*Sambag Categorys Filters Js */
$(".tags--collection li").click(function (e) {

    product_type = $(this).attr('data-id');
    product_type_name= findAndReplace(product_type," ","-")
    newURL = '/collections/';
    if (size_muliple.q) {
        e.preventDefault();

        if (product_type_name == "All") {
            newURL = '/collections/' + 'all';

        } else {

            newURL += product_type_name.toLowerCase() + '?types=' + product_type;
        }
        window.location.href = newURL;
    }

});
/*Sambag Categorys Filters Js  Close*/

/*Sambag Size Filters Js */
jQuery('#select_size').on("change", function (e) {
    e.preventDefault();
    var handle=$(".collection-url").val();
    value = $(this).val();
    newURL = '/collections';
    style_value = $(".tag--active").attr('data-id');
    style_value_space= findAndReplace(style_value," ","-");
    console.log(handle);

    if (value != "") {
       // newURL += '/' + style_value_space.toLowerCase() + '?q=' + value;
        newURL += '/' + handle + '?q=' + value;


    }
    else {
        newURL = '/collections/' + 'All';

    }
    window.location.href = newURL;
});
/* Replace String */
function findAndReplace(string, target, replacement) {

    var i = 0, length = string.length;

    for (i; i < length; i++) {

        string = string.replace(target, replacement);

    }

    return string;

}
/* Replace String Close*/
/*Sambag Size filters js  Close */


/* Top products image scalling for 4k */
//$('.collection-grid__item-overlay').css('background-size', 'contain');

/* Top products image scalling for 4k */

/* */
/* News Letter  Pop Up Box Form */
var success_url = window.location.href.split('?result=').pop();
var urlInput = document.getElementById("ci_consenturl");
if (urlInput != null && urlInput != 'undefined') {
    urlInput.value = encodeURI(window.location.href);
}


function checkbox_Clicked(element) {
    document.getElementById(element.id + "_unchecked").value = !element.checked;
}

function validate_signup(frm, showAlert) {
    var emailAddress = frm.email.value;
    var errorString = '';
    if (emailAddress == '' || emailAddress.indexOf('@') == -1) {
        errorString = 'Please enter your email address';
    }
    var isError = false;
    if (errorString.length > 0) {
        isError = true;
        if (showAlert) alert(errorString);
    }
    return !isError;
}
$('#signup #POSTCODE').on('keyup', function () {

    var thisValue = $(this).val();
    var lastChar = thisValue.charAt(thisValue.length - 1);
    if (isNaN(lastChar)) {
        $(this).val(thisValue.slice(0, thisValue.length - 1));
    }
});
$('#signup1 #POSTCODE').on('keyup', function () {

    var thisValue = $(this).val();
    var lastChar = thisValue.charAt(thisValue.length - 1);
    if (isNaN(lastChar)) {
        $(this).val(thisValue.slice(0, thisValue.length - 1));
    }
});
var sign_up_news_letter = getCookie("sign_up_news_letter");
var news_letter_popup_7_days = getCookie("news_letter");
var news_letter_30days = getCookie("news_letter_30days");
var date_now = new Date().getTime().toString();

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 1000 * 60 * 60 * 24));
    var expires = "expires=" + d.toGMTString();
    window.document.cookie = cname + "=" + cvalue + "; " + expires;
}
function getCookie(c_name) {
    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}
function deleteCookie(cname) {
    var d = new Date();
    d.setTime(d.getTime() - (1000 * 60 * 60 * 24));
    var expires = "expires=" + d.toGMTString();
    window.document.cookie = cname + "=" + "; " + expires;

}

/* Sydney Date Set For Newsletter Pop Up Hide*/

var date_format=new Date('Mar 08 2019 17:00:00 UTC +11');
var date = new Date();

if(date_format < date){
    if (sign_up_news_letter.length > 0) {
        $("#news-letter").hide();
    }
    else if (news_letter_popup_7_days.length === 0 && sessionStorage.getItem("model-close") == null && success_url !== "success") {
        setTimeout(function () {
            $('#news-letter').modal('show');
        }, 30000);

    }
    else if (news_letter_popup_7_days.length > 0 && date_now >= news_letter_popup_7_days && news_letter_30days.length <= 0 && success_url !== "success") {
        daysToExpire = 30;
        if (sessionStorage.getItem("model-close") == null) {

            $('#news-letter').modal('show');

        }
        setCookie("news_letter_30days", new Date().getTime() + daysToExpire * 1000 * 60 * 60 * 24, 2000);
    }
    else if (news_letter_30days.length > 0 && date_now >= news_letter_30days && sessionStorage.getItem("model-close") == null && success_url !== "success") {
        daysToExpire = 7;
        setCookie("news_letter", new Date().getTime() + daysToExpire * 1000 * 60 * 60 * 24, 2000);
        deleteCookie("news_letter_30days");

        $('#news-letter').modal('show');

    }
    $('#news-letter').on('hide.bs.modal', function () {
        sessionStorage.setItem("model-close", true);
        if (news_letter_popup_7_days.length <= 0) {
            daysToExpire = 7;
            setCookie("news_letter", new Date().getTime() + daysToExpire * 1000 * 60 * 60 * 24, 2000);
        }
    });
}else{
    $('#news-letter').modal('hide');
}
/* Sydney Date Set For Newsletter Pop Up Hide*/



$(".success-message").hide();
$(".response-success").hide();

if (success_url == "success") {
    setCookie("sign_up_news_letter", true, 2000);
    // console.log(sign_up_news_letter.length);
    if (sign_up_news_letter.length > 0 || news_letter_popup_7_days.length > 0 || news_letter_30days.length > 0) {

        $(".response-success").show();
        // $("#signup").css("display", "none");
        $("#signup1").css("display", "none");
        $(".subscribe-hide").css("display", "none");
        //  localStorage.setItem("sign_up_news_letter", true)

    }

    else {
        setCookie("sign_up_news_letter", true, 2000);
        setTimeout(function () {
            $('#news-letter').modal('show');
            $(".success-message").show();
        }, 1000);
        $("#signup").css("display", "none");
    }


}

/* News Letter  Pop Up Box Form Close*/
/* Shop Our  Products */
function getCaontainerH() {
    if ($('body[class*="template-customers"]').length && $('#PageContainer > .main-content')) {
        var winH = $(window).height() - ($('#shopify-section-header').height() + 35);
        var contentH = $('#PageContainer > .main-content').height();
        //console.log(contentH + ' and ' + $(window).height() + ' and ' + $('#shopify-section-header').height());
        if (contentH < winH) {
            $('#PageContainer > .main-content').addClass('less-height').css('min-height', winH);
        } else {
            if ($('#PageContainer > .main-content').hasClass('less-height')) {
                $('#PageContainer > .main-content').removeClass('less-height').css('min-height', 'initial');
            }
        }
    }
}



//Blog Article Square Images
function blogArticleImgSquare(){
    $('.blog-article-container img, .blog-article-container p img').each(function(el){
        var min = Math.min($(this).width(), $(this).height())
        $(this).height(min)
        $(this).width(min)

    });
}
// End Blog Article Square Images
blogArticleImgSquare();


//hide the instafeed in style-circle page
if(window.location.pathname == '/pages/style-circle'){$('#insta-feed').hide()}

$('.login, .join').on('click',function(){
    window.location.href = '/account/login';
})


/* Shop Our Products Close*/

$('.move[data-move]').on('click', function () {

    if ($(this).attr('data-move') == 'right') {
        $('.size-guide-scroll-tbl').scrollLeft(300);
        $(this).attr('data-move', 'left');
        $(this).html('&lt;');
    } else {
        $('.size-guide-scroll-tbl').scrollLeft(0);
        $(this).attr('data-move', 'right');
        $(this).html('&gt;');
    }
});

$('.size-guide-scroll-tbl').scroll(function () {

    var $width = $('.size-guide-scroll-tbl').outerWidth()
    var $scrollWidth = $('.size-guide-scroll-tbl')[0].scrollWidth;
    var $scrollLeft = $('.size-guide-scroll-tbl').scrollLeft();

    if ($scrollWidth - $width <= $scrollLeft) {


        $('.move[data-move]').attr('data-move', 'left');
        $('.move[data-move]').html('&lt;');
    }
    if ($scrollLeft === 0) {
        $('.move[data-move]').attr('data-move', 'right');
        $('.move[data-move]').html('&gt;');
    }
});




//Home page containers square
$(window).load(function () {

    if ($(window).width() < 591) {
        var featureSecW = $('.feature-row__text').width();
        $('.feature-row__text,.newsletter').css('min-height', 400);
        var craftmanImg = $('.sambag-story .item img').height();
        $('.item.item-text').css('min-height', craftmanImg);
    }
});



$(document).ready(function () {
    getCaontainerH();
    blogArticleImgSquare();

});
$(window).resize(function () {
    getCaontainerH();
    blogArticleImgSquare();
});
